import { ApiClient } from "@/api-client/src/core/api-client";
import { ShippingPolicyApiResponse, CountryCurrencyOptionResponse } from "@/packages/types/shipping";

const apiClient = new ApiClient();
const webService = apiClient.web;

/**
 * Fetches public country shipping rules and policies.
 */
export const fetchPublicShippingPolicies = async (): Promise<ShippingPolicyApiResponse> => {
  const response = await webService.get<ShippingPolicyApiResponse>("/shipping");
  return response;
};

/**
 * Fetches lightweight unique country-currency shipping options.
 */
export const fetchCountryCurrencyOptions = async (): Promise<CountryCurrencyOptionResponse> => {
  const response = await webService.get<CountryCurrencyOptionResponse>("/shipping/country-options");
  console.log("Fetched country-currency options:", response);
  return response;
};

